export const therapyOptions = [
  { label: "Physical Therapy", value: "physical_therapy" },
  { label: "Occupational Therapy", value: "occupational_therapy" },
  { label: "Speech Therapy", value: "speech_therapy" },
  { label: "Cognitive Behavioral Therapy", value: "cognitive_behavioral" },
  { label: "Respiratory Therapy", value: "respiratory_therapy" },
  { label: "Dialysis", value: "dialysis" },
  { label: "Chemotherapy", value: "chemotherapy" },
  { label: "Radiation Therapy", value: "radiation_therapy" },
];
